import { createContext } from "react"

import type { LocationPickerConfig } from "./typings"

export type LocationPickerContextType = (func: (close: () => void) => LocationPickerConfig) => void

export const LocationPickerContext = createContext<LocationPickerContextType>(() => {
	throw new Error("No LocationPickerProvider found")
})
